module.exports = __webpack_public_path__ + "img/icon-games-black.03620bbd.svg";